import React from 'react'
import Lifecycle from '@squarespace/core/Lifecycle'
import PageComponent from '../../components/Page'

class Blog extends React.Component {
  componentDidMount() {
    window.Squarespace = { afterBodyLoad: () => {} }
    Lifecycle.init()

    const images = Array.from(document.getElementsByTagName('IMG'))
    images.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src
        img.parentNode.style.paddingBottom = 0
      }
    })
  }

  render() {
    return (
      <PageComponent
        data={{
          html: this.props.pageContext.body,
          title: this.props.pageContext.title,
          banner: {
            static: <h1>{this.props.pageContext.title}</h1>,
          },
        }} 
      />
    )
  }
}

export default Blog